export const PLAYLIST = 'PLAYLIST';
export const SET_IN_PLAYLIST = 'SET_IN_PLAYLIST';
export const SET_TRACK_IN_PLAYLIST = 'SET_TRACK_IN_PLAYLIST';
export const REMOVE_TRACK_FROM_PLAYLIST = 'REMOVE_TRACK_FROM_PLAYLIST';
export const RESET_PLAYLIST = 'RESET_PLAYLIST';
export const SET_SHUFFLE_MODE = 'SET_SHUFFLE_MODE';
export const SET_REPEAT_MODE = 'SET_REPEAT_MODE';
export const SET_IS_OPEN_PLAYLIST = 'SET_IS_OPEN_PLAYLIST';
